import styled from 'styled-components';

export const Image = styled.img`
  height: auto;
  max-width: 100%;
`;
